import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useLocation } from 'react-router-dom';
import TransitionContainer from './TransitionContainer';
import { useAppState } from '../state/StateContext';
import ErrorPage from './ErrorPage';

interface PageContainerProps {
  children: React.ReactNode;
}

const useStyles = createUseStyles({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f1f1f1',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    minHeight: '400px',
    padding: '30px 20px',
  },
  contentContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '1000px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  debug: {
    padding: '10px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    margin: '10px 0',
    borderRadius: '4px',
    overflow: 'auto',
  },
});

const PageContainer: React.FC<PageContainerProps> = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();
  const state = useAppState();

  // Track previous path to determine animation direction
  const [previousPath, setPreviousPath] = useState<string>(location.pathname);

  // Update direction when path changes
  useEffect(() => {
    // If we're moving from root to a deeper path, set direction to forward (0)
    // If we're moving from a deeper path to root, set direction to backward (1)
    if (location.pathname !== previousPath) {
      if (location.pathname.length > previousPath.length) {
        state.direction.set(0); // Forward
      } else {
        state.direction.set(1); // Backward
      }
      setPreviousPath(location.pathname);
    }
  }, [location.pathname, previousPath, state.direction]);

  return (
    <>
      {state?.isError?.get() ? (
        <ErrorPage />
      ) : (
        <div className={classes.pageContainer}>
          <div className={classes.contentContainer}>
            <TransitionContainer show={true} direction={state.direction.get()}>
              {children}
            </TransitionContainer>
          </div>
        </div>
      )}
    </>
  );
};

export default PageContainer;
